var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 7.75,
    fill: "#FAFAFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 7.75,
    stroke: "#E9E9E9",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53583 10.9068L8.50701 11.9356C7.62833 12.8143 7.62833 14.2389 8.50701 15.1176C9.38569 15.9963 10.8103 15.9963 11.689 15.1176L13.0603 13.7463C13.939 12.8676 13.939 11.443 13.0603 10.5643C12.8744 10.3783 12.664 10.2317 12.4394 10.1245L11.9996 10.5643C11.9539 10.61 11.9153 10.6602 11.8839 10.7134C12.1204 10.7812 12.3436 10.9083 12.53 11.0946C13.1158 11.6804 13.1158 12.6302 12.53 13.216L11.1587 14.5873C10.5729 15.1731 9.62312 15.1731 9.03734 14.5873C8.45155 14.0015 8.45155 13.0517 9.03734 12.466L9.63179 11.8715C9.54764 11.5564 9.51566 11.2303 9.53583 10.9068Z",
    fill: "#202123"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.939 9.50364C10.0603 10.3823 10.0603 11.8069 10.939 12.6856C11.1249 12.8716 11.3353 13.0182 11.5598 13.1254L12.1415 12.5437C11.8953 12.478 11.6625 12.3485 11.4693 12.1553C10.8835 11.5695 10.8835 10.6198 11.4693 10.034L12.8406 8.66265C13.4264 8.07686 14.3762 8.07686 14.962 8.66265C15.5477 9.24844 15.5477 10.1982 14.962 10.784L14.3675 11.3784C14.4516 11.6935 14.4836 12.0196 14.4635 12.3431L15.4923 11.3143C16.371 10.4356 16.371 9.011 15.4923 8.13232C14.6136 7.25364 13.189 7.25364 12.3103 8.13232L10.939 9.50364Z",
    fill: "#202123"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkModalIcon);
export default __webpack_public_path__ + "static/media/linkModalIcon.4ace7cb865f8e3a278a31915c832bf2d.svg";
export { ForwardRef as ReactComponent };